import { forwardRef } from 'react'
import PropTypes from 'prop-types'

/**
 * The primary action: a solid cover-orange button with ink text (5.8:1),
 * 8px corners, a one-step deeper hover and a 0.98 press. One per section or
 * record. `variant="word"` is the secondary action: a quiet underlined text
 * link. `perforation` and `torn` are accepted for older callers and ignored.
 */
const Stub = forwardRef(function Stub(
  {
    as: Tag = 'button',
    variant = 'primary',
    // eslint-disable-next-line no-unused-vars
    perforation,
    // eslint-disable-next-line no-unused-vars
    torn,
    className = '',
    children,
    ...rest
  },
  ref
) {
  if (variant === 'word') {
    return (
      <Tag
        ref={ref}
        className={`inline-flex items-center gap-1.5 font-sans font-medium text-ink underline decoration-ink/30 underline-offset-4 hover:decoration-live-deep hover:text-live-deep transition-colors ${className}`}
        {...rest}
      >
        {children}
      </Tag>
    )
  }
  return (
    <Tag ref={ref} className={`stub ${className}`} {...rest}>
      {children}
    </Tag>
  )
})

Stub.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(['primary', 'word']),
  // No longer draws anything; kept so existing callers need no change.
  perforation: PropTypes.oneOf(['left', 'top', 'none']),
  torn: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Stub
